<div class="text-gray-500 italic opacity-70 w-full text-center text-sm p-2">

  @if (customMessage) {
    <div>{{ customMessage }}</div>
  } @else {
    {{ 'NoInformationToDisplay' | localizeText : 'No Information To Display' }}
  }

</div>
